// Shared palette for inline styles. The brand/text colors align with the
// Semantic UI Less theme (src/semantic-ui/**/*.variables); a few tokens
// (amber and its tints, green tints, surface, border, textFaint) are
// app-specific and defined only here.
export const colors = {
  teal: "#58b9b7",
  violet: "#98a0d9",
  purple: "#ca98d9",
  green: "#5cb958",
  amber: "#e0b34d",
  amberTint: "rgba(224, 179, 77, 0.1)",
  amberBorder: "rgba(224, 179, 77, 0.4)",
  greenTint: "rgba(92, 185, 88, 0.12)",
  greenText: "#9edb9b",
  tealTint: "rgba(88, 185, 183, 0.12)",
  tealBorder: "rgba(88, 185, 183, 0.5)",
  tealText: "#9ee0de",
  violetTint: "rgba(152, 160, 217, 0.12)",
  violetBorder: "rgba(152, 160, 217, 0.3)",
  errorText: "#f2a19a",
  pageBackground: "#1b1b27",
  surface: "#222333",
  border: "rgba(255, 255, 255, 0.08)",
  text: "#ffffff",
  textStrong: "rgba(255, 255, 255, 0.85)",
  textMuted: "rgba(255, 255, 255, 0.6)",
  textLight: "rgba(255, 255, 255, 0.5)",
  textFaint: "rgba(255, 255, 255, 0.4)",
};

export const style = {
  gradientButton: {
    color: "white",
    background:
      "transparent linear-gradient(140deg, #98A0D9 0%, #58B9B6 100%) 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    border: "1px solid #D2D3EC",
  },
  gradientButtonInactive: {
    color: "white",
    background: "transparent ",
    boxShadow: "0px 3px 6px #00000029",
    border: "1px solid #D2D3EC",
  },
  purpleGradientButton: {
    color: "white",
    background:
      "transparent linear-gradient(128deg, #98A0D9 0%, #CA98D9 100%) 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    border: "1px solid #D2D3EC",
  },
  modalSummaryButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "8px 21px",
    width: "140px",
    justifyContent: "space-around",
  },
};
